import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { professionalAction, userActions } from "../../_actions";
import { TableReportSup4 } from "./Tables/TableReportSup4";

import { LanguageContext } from "../../context/LanguageContext";

import { AppTable } from "../../_components/AppTable";
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  Select,
  DatePicker,
  Divider,
  PageHeader,
  Descriptions,
  message,
  Modal,
  Spin,
  Space,
  Menu,
  Dropdown,
  Radio,
} from "antd";
import { Document4 } from "./ReportDocuments/Document_4";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  DownOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import ReportsTable from "./ReportsTable";
//import { TableReport4 } from "./Tables/Table4";
import * as XLSX from "xlsx-js-style";
import moment from "moment";
import {
  downloadReportPdf,
  getDefaultReportFooter,
  getReportDateRangeText,
  getReportHeaderText,
} from "../../_helpers/downloadReportPdf";

const TableReport4 = React.lazy(() =>
  import("./Tables/Table4").then((module) => ({
    default: module.TableReport4,
  })),
);

const { RangePicker } = DatePicker;
const { Option } = Select;

// class Reports4 extends React.Component {
//   static contextType = LanguageContext;
//   constructor(props) {
//     super(props);
//     this.myTableRef = React.createRef();
//   }

class Reports4 extends React.Component {
  static contextType = LanguageContext;

  constructor(props) {
    super(props);
    this.myTableRef = React.createRef();
  }

  state = {
    loading: false,
    downloadLoding: false,
    report_4_startDate: "",
    report_4_endDate: "",
    report4_loader: false,
    report4_List: [],
    report4_List_Total: 0,
    report4_API_loader: false,
    totalCriminal: 0,
    download: "excel",
    advancedFilterPhoto: "all",
  };
  getExportRows = () => {
    const { t } = this.context;
    const arrData1 = this.state.report4_List;

    return (
      arrData1?.map((data, index) => ({
        "अ.क्र": index + 1,
        नाव: data.name,
        "आरोपीचे पोलिस ठाण": data.districtName,
        "अंतिम तपासणी दिनांक": data.lastUpdate
          ? moment.unix(data.lastUpdate, "YYYY-MM-DD").format("DD-MM-YYYY")
          : "-",
        एकूण: data.activeUser ? data.activeUser : 0,
        फोटो: data.photo ? "हो" : "नाही",
      })) || []
    );
  };

  download_pdf = async () => {
    const { t } = this.context;
    const arrData = this.getExportRows();

    if (!arrData.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }

    const title = t("accused_not_yet_checked");
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const headerText = getReportHeaderText({
      user: this.props?.user,
      cityName: this.getCityName(this.props?.user?.cityId || ""),
      districtName: this.state.district_name,
    });

    this.setState({ downloadLoding: true });
    try {
      await downloadReportPdf({
        headerText,
        reportTitle: title,
        dateRangeText: getReportDateRangeText(
          this.state.report_4_startDate,
          this.state.report_4_endDate,
        ),
        arrData,
        fileName: file_name,
        footerText: getDefaultReportFooter(),
      });
    } catch (error) {
      console.error(error);
      message.error("Failed to generate PDF report");
    } finally {
      this.setState({ downloadLoding: false });
    }
  };

  downloadReport = () => {
    const { download } = this.state;
    if (download == "excel") {
      this.download_csv();
    }
    if (download == "pdf") {
      this.download_pdf();
    }
  };

  getDistrictsid = () => {
    const { user } = this.props;
    console.log("users id", this.props);
    professionalAction.getDistrictsid(user.districtId).then((res) => {
      console.log("res", res);

      const tempData = res.pc_districts;
      console.log("text", tempData[0]?.DistrictName);
      this.setState({
        district_name: tempData[0]?.DistrictName,
      });
    });
  };
  componentDidMount() {
    this.props.dispatch(professionalAction.getCity());
    if (this.props.user.role === "2") {
      this.getDistrictsid();
    }
  }

  // downloadReport1 = async () => {
  //   const { user } = this.props;
  //   let obj = {
  //     startDate: this.state.report_4_startDate,
  //     endDate: this.state.report_4_endDate,
  //     cityId: user && user.cityId,
  //   };
  //   this.setState({
  //     report4_loader: true,
  //   });
  //   const blob = await pdf(
  //     <Document4
  //       rows={this.state.report4_List}
  //       filterDate={obj}
  //       allTotal={this.state.totalCriminal}
  //       total={this.state.report4_List_Total}
  //     />
  //   ).toBlob();

  //   if (blob) {
  //     this.setState({
  //       report4_loader: false,
  //     });
  //     saveAs(blob, "अद्याप चेक न केलेले आरोपी");
  //   }
  // };

  downloadReport1 = async () => {
    const { user } = this.props;
    const { t } = this.context;
    let obj = {
      startDate: this.state.report_4_startDate,
      endDate: this.state.report_4_endDate,
      cityId: user && user.cityId,
    };
    this.setState({ report4_loader: true });

    const blob = await pdf(
      <Document4
        rows={this.state.report4_List}
        filterDate={obj}
        allTotal={this.state.totalCriminal}
        total={this.state.report4_List_Total}
      />,
    ).toBlob();

    if (blob) {
      this.setState({ report4_loader: false });
      saveAs(blob, t("accused_not_yet_checked")); // ✅ Replaced static string
    }
  };

  download_csv = () => {
    const { t } = this.context;
    const ReportTitle = t("accused_not_yet_checked").replace(/\s/g, "_");
    const title = t("accused_not_yet_checked");
    const arrData1 = this.state.report4_List;
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const list =
      arrData1?.map((data, index) => ({
        "अ.क्र": index + 1,
        नाव: data.name,
        "आरोपीचे पोलिस ठाण": data.districtName,
        "अंतिम तपासणी दिनांक": data.lastUpdate
          ? moment.unix(data.lastUpdate, "YYYY-MM-DD").format("DD-MM-YYYY")
          : "-",
        एकूण: data.activeUser ? data.activeUser : 0,
        फोटो: data.photo ? "हो" : "नाही",
      })) || [];

    const arrData = list;

    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A4" });

    const columnWidths = Object.keys(arrData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length),
        ) + 6,
    }));

    ws["!cols"] = columnWidths;

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    Object.keys(arrData[0]).forEach((_, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: colIndex });
      if (ws[cellRef]) {
        ws[cellRef].s = headerStyle;
      }
    });

    arrData.forEach((row, rowIndex) => {
      Object.values(row).forEach((_, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 4,
          c: colIndex,
        });
        if (ws[cellRef]) {
          ws[cellRef].s = cellStyle;
        }
      });
    });

    console.log("this props.user", this.props.user);
    const cityName = this.getCityName(this.props?.user?.cityId || "");
    console.log("cityName", cityName);
    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;
    const headerData =
      this.props?.user?.role === "2"
        ? `${stateName} (${cityName})`
        : `${cityName}`;

    ws["A1"] = { v: headerData, t: "s" };
    ws["A1"].s = titleStyle;

    ws["A2"] = { v: ReportTitle, t: "s" };
    ws["A2"].s = subTitleStyle;

    ws["A3"] = {
      v: `From: ${
        moment(this.state.report_4_startDate).format("DD-MM-YYYY") || "-"
      } To ${moment(this.state.report_4_endDate).format("DD-MM-YYYY") || "-"}`,
      t: "s",
    };

    ws["A3"].s = subTitleStyle;

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 6;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
      { s: { r: 2, c: 0 }, e: { r: 2, c: columnWidths.length - 1 } },
    ];

    ws["!merges"] = mergeRanges;

    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };
  generatePDFReport1 = async () => {
    const { user } = this.props;
    let obj;
    if (user.role === "4") {
      obj = {
        startDate: this.state.report_4_startDate,
        endDate: this.state.report_4_endDate,
        cityId: user && user.cityId,
      };
    } else {
      obj = {
        startDate: this.state.report_4_startDate,
        endDate: this.state.report_4_endDate,
        id: user && user.id,
        cityId: user && user.cityId,
      };
    }

    this.setState({
      report4_API_loader: true,
    });
    professionalAction.getReport4(obj).then((res) => {
      res &&
        res &&
        res.text().then(async (text) => {
          const tempData = text && JSON.parse(text);
          const tempFilterData = _.filter(
            tempData && tempData.data && _.flatten(tempData.data),
            function (o) {
              return Object.keys(o).length !== 0;
            },
          );
          this.setState({
            report4_API_loader: false,
            report4_List: tempFilterData,
            report4_List_Total: tempData && tempData.totalCheckedCriminals,
            totalCriminal: tempData && tempData.totalAllCriminal,
            report4_List_backup: tempFilterData,
          });
        });
    });
  };

  onFinishDateRangeGPSReport1 = (values) => {
    if (values) {
      let dates =
        values &&
        values.map((item) => {
          return item.toISOString();
        });
      this.setState({
        report_4_startDate: dates[0],
        report_4_endDate: dates[1],
      });
    }
  };

  onStartDateChange = (date) => {
    if (date) {
      const startDate = date.toISOString();

      this.setState({
        report_4_startDate: startDate,
        report_4_endDate: null,
      });
    }
  };
  onEndDateChange = (date) => {
    if (date) {
      const endDate = date.toISOString();

      this.setState({
        report_4_endDate: endDate,
      });
    }
  };

  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  isloading = () => {
    this.setState({ loading: true });
  };

  isNotloading = () => {
    this.setState({ loading: false });
  };

  // render() {
  //   const { users } = this.props;
  //   const { user } = this.props;
  //   const { professionals } = this.props;
  //   const { pc_cities, loading } = professionals;
  //   const { t } = this.context;

  //   return (
  //     <Spin spinning={this.state.loading} delay={500}>
  //       <div className="col-md-6 col-md-offset-3">
  //         <div className="site-page-header-ghost-wrapper">
  //           <PageHeader
  //             className="site-page-header"
  //             ghost={false}
  //             onBack={false}
  //             title={user && user.userid}
  //             subTitle={
  //               user && user.role === "4" ? "( ADMIN )" : "( SUPER ADMIN )"
  //             }
  //           ></PageHeader>
  //           <PageHeader
  //             className="site-page-header"
  //             ghost={false}
  //             onBack={false}
  //             title="अद्याप चेक न केलेले आरोपी"
  //           >
  //             <div
  //               style={{
  //                 display: "flex",
  //                 justifyContent: "space-between",
  //                 alignItems: "center",
  //                 flexWrap: "wrap",
  //               }}
  //             >
  //               {/* Date Selection and Preventive Action Dropdown */}
  //               <div
  //                 style={{
  //                   display: "flex",
  //                   gap: "10px",
  //                   alignItems: "center",
  //                   flex: 1,
  //                 }}
  //               >
  //                 <Descriptions size="small" column={1}>
  //                   <Descriptions.Item label="Select Date">
  //                     <RangePicker
  //                       onChange={(val) =>
  //                         this.onFinishDateRangeGPSReport1(val)
  //                       }
  //                       style={{ marginRight: 10 }}
  //                       inputReadOnly
  //                     />
  //                   </Descriptions.Item>
  //                 </Descriptions>

  //                 {/* Find Button */}
  //                 <div
  //                   style={{
  //                     width: "100%",
  //                     display: "flex",
  //                     justifyContent: "center",
  //                   }}
  //                 >
  //                   <Button
  //                     type="primary"
  //                     disabled={!this.state.report_4_startDate}
  //                     loading={this.state.report4_API_loader}
  //                     onClick={this.generatePDFReport1}
  //                   >
  //                     Find
  //                   </Button>
  //                 </div>
  //               </div>

  //               {/* Download Dropdown & Button */}
  //               <Space direction="horizontal" size="middle">
  //                 <Form>
  //                   <Form.Item
  //                     name="condition"
  //                     rules={[
  //                       {
  //                         required: true,
  //                         message: "Please select a value",
  //                       },
  //                     ]}
  //                     style={{ marginBottom: 0 }}
  //                   >
  //                     <Select
  //                       placeholder="कृपया पर्याय निवडा"
  //                       value={this.state.download}
  //                       onChange={(value) => this.setState({ download: value })}
  //                       style={{ width: 150 }}
  //                       disabled={!this.state.report4_List.length}
  //                     >
  //                       <Option key="excel" value="excel">
  //                         एक्सेल
  //                       </Option>
  //                     </Select>
  //                   </Form.Item>
  //                 </Form>

  //                 {/* Download Button */}
  //                 {this.state.download && (
  //                   <Button
  //                     type="primary"
  //                     style={{ minWidth: 120 }}
  //                     onClick={this.downloadReport}
  //                   >
  //                     Download
  //                   </Button>
  //                 )}
  //               </Space>
  //             </div>
  //           </PageHeader>

  //           <React.Suspense fallback={<div>Loading...</div>}>
  //             <TableReport4
  //               data={this.state.report4_List}
  //               allTotal={this.state.totalCriminal}
  //               total={this.state.report4_List_Total}
  //             ></TableReport4>
  //           </React.Suspense>
  //         </div>
  //         <ReportsTable
  //           isNotloading={this.isNotloading}
  //           ref={this.myTableRef}
  //           rows={this.state.report4_List}
  //           startDate={this.state.report_4_startDate}
  //           endDate={this.state.report_4_endDate}
  //           cityId={
  //             this.props ? this.props?.user && this.props?.user.cityId : null
  //           }
  //           heading="अद्याप चेक न केलेले आरोपी"
  //           allTotal={this.state.totalCriminal}
  //           total={this.state.report4_List_Total}
  //           cityName={this.getCityName(
  //             this.props?.user && this.props?.user.cityId
  //           )}
  //           user={this.props?.user?.role}
  //           report_type="चेक_न_आरोपी"
  //           report_name="अद्याप चेक न केलेले आरोपी"
  //         />
  //       </div>
  //     </Spin>
  //   );
  // }

  sortby = (name, direction) => {
    this.setState({
      order_by: name,
      direction: direction,
    });

    const { report4_List } = this.state;

    const sortedData = [...report4_List].sort((a, b) => {
      let x = a[name] ?? "";
      let y = b[name] ?? "";

      // If both values are numeric strings → sort as numbers
      const isNumeric = !isNaN(x) && !isNaN(y);

      if (isNumeric) {
        x = Number(x);
        y = Number(y);
        return direction === "ASC" ? x - y : y - x;
      }

      // Otherwise sort as strings
      x = x.toString().toLowerCase();
      y = y.toString().toLowerCase();

      return direction === "ASC" ? x.localeCompare(y) : y.localeCompare(x);
    });

    this.setState({ report4_List: sortedData });
  };
  handleAdvancedFilterPhotoChange = (e) => {
    const value = e.target.value;
    this.setState({ advancedFilterPhoto: value });

    const { report4_List_backup, report4_List } = this.state; // keep original data safe

    let filtered;

    if (value === "yes") {
      filtered = report4_List_backup.filter(
        (item) =>
          item.photo !== null && item.photo !== "" && item.photo !== undefined,
      );
    } else if (value === "no") {
      filtered = report4_List_backup.filter(
        (item) =>
          item.photo === null || item.photo === "" || item.photo === undefined,
      );
    } else {
      filtered = report4_List_backup;
    }

    this.setState({ report4_List: filtered, total: filtered.length });
  };
  render() {
    const { user, professionals } = this.props;
    const { pc_cities } = professionals;
    const { t } = this.context;
    const { key, direction } = this.state;
    const menu = (
      <Menu onClick={this.filterkey} style={{ width: "200px", padding: "8px" }}>
        <Menu.Item key="registernumber">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            गणना
            <ArrowUpOutlined
              title="ASC"
              style={{
                color:
                  key === "registernumber" && direction === "ASC"
                    ? "#1890ff"
                    : "#bfbfbf",
              }}
              onClick={() => this.sortby("registernumber", "ASC")} // Toggle to ASC
            />
            <ArrowDownOutlined
              title="DESC"
              style={{
                color:
                  key === "registernumber" && direction === "DESC"
                    ? "#1890ff"
                    : "#bfbfbf",
              }}
              onClick={() => this.sortby("registernumber", "DESC")} // Toggle to DESC
            />
          </div>
        </Menu.Item>
        <Menu.Item key="name">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            नाव
            <ArrowUpOutlined
              title="ASC"
              style={{
                color:
                  key === "name" && direction === "ASC" ? "#1890ff" : "#bfbfbf",
              }}
              onClick={() => this.sortby("name", "ASC")} // Toggle to ASC
            />
            <ArrowDownOutlined
              title="DESC"
              style={{
                color:
                  key === "name" && direction === "DESC"
                    ? "#1890ff"
                    : "#bfbfbf",
              }}
              onClick={() => this.sortby("name", "DESC")} // Toggle to DESC
            />
          </div>
        </Menu.Item>
      </Menu>
    );

    return (
      <Spin spinning={this.state.loading} delay={500}>
        <div className="col-md-6 col-md-offset-3">
          <div className="site-page-header-ghost-wrapper">
            <PageHeader
              className="site-page-header"
              ghost={false}
              onBack={false}
              title={user && user.userid}
              subTitle={
                user && user.role === "4" ? "( ADMIN )" : "( SUPER ADMIN )"
              }
            />

            <PageHeader
              className="site-page-header"
              ghost={false}
              onBack={false}
              title={t("accused_not_yet_checked")} // ✅ Translated title
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    flex: 1,
                  }}
                >
                  <Descriptions size="small" column={1}>
                    <Descriptions.Item label={t("select_date")}>
                      {" "}
                      {/* ✅ Translated label */}
                      {/* <RangePicker
                        onChange={(val) =>
                          this.onFinishDateRangeGPSReport1(val)
                        }
                        style={{ marginRight: 10 }}
                        inputReadOnly
                        format={"DD/MM/YYYY"}
                      /> */}
                      <DatePicker
                        style={{ flex: 1, minWidth: "150px" }}
                        value={
                          this.state.report_4_startDate
                            ? moment(this.state.report_4_startDate)
                            : null
                        }
                        onChange={this.onStartDateChange}
                        placeholder="DD/MM/YYYY"
                        allowClear
                        format={"DD/MM/YYYY"}
                        inputReadOnly
                      />
                      <DatePicker
                        style={{
                          flex: 1,
                          minWidth: "150px",
                          marginLeft: "10px",
                        }}
                        value={
                          this.state.report_4_endDate
                            ? moment(this.state.report_4_endDate)
                            : null
                        }
                        onChange={this.onEndDateChange}
                        placeholder="DD/MM/YYYY"
                        allowClear
                        format={"DD/MM/YYYY"}
                        inputReadOnly
                      />
                    </Descriptions.Item>
                  </Descriptions>

                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      type="primary"
                      disabled={!this.state.report_4_startDate}
                      onClick={this.generatePDFReport1}
                    >
                      {t("find")} {/* ✅ Translated button */}
                    </Button>
                  </div>
                </div>

                <Space direction="horizontal" size="middle">
                  <Form>
                    <Form.Item
                      name="condition"
                      rules={[{ required: true }]}
                      style={{ marginBottom: 0 }}
                    >
                      <Select
                        placeholder={t("please_select_an_option")}
                        value={this.state.download}
                        onChange={(value) => this.setState({ download: value })}
                        style={{ width: 150 }}
                        disabled={!this.state.report4_List.length}
                      >
                        <Option key="excel" value="excel">
                          {t("excel")}
                        </Option>
                        <Option key="pdf" value="pdf">PDF</Option>
                      </Select>
                    </Form.Item>
                  </Form>

                  {this.state.download && (
                    <Button
                      type="primary"
                      style={{ minWidth: 120 }}
                      onClick={this.downloadReport}
                    >
                      {t("download")}
                    </Button>
                  )}
                  <Dropdown
                    overlay={menu}
                    placement="bottomRight"
                    arrow
                    disabled={!this.state.report4_List?.length}
                  >
                    <Button type="ghost">
                      {t("sorter_by")} <DownOutlined />
                    </Button>
                  </Dropdown>
                </Space>
              </div>
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                }}
              >
                <label style={{ fontSize: "15px", fontWeight: "500" }}>
                  फोटो:
                </label>

                <Radio.Group
                  onChange={this.handleAdvancedFilterPhotoChange}
                  value={this.state.advancedFilterPhoto}
                  disabled={!this.state.report4_List.length}
                >
                  <Radio value="all">सर्व</Radio>
                  <Radio value="yes">होय</Radio>
                  <Radio value="no">नाही</Radio>
                </Radio.Group>
              </div>
            </PageHeader>
            <TableReportSup4
              data={this.state.report4_List}
              allTotal={this.state.totalCriminal}
              total={this.state.report4_List_Total}
              loading={this.state.report4_API_loader}
            />
          </div>
        </div>
      </Spin>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}

const connectedReports4 = connect(mapStateToProps)(Reports4);
export { connectedReports4 as Reports4 };
